/* ============================================================
   LiquorVerse cocktail scaler (cocktail-page-v7).
   ALL quantity formatting goes through the shared §2.6 helper
   (window.LV) — the regex bug that bit the prototype scaler
   lives in history, not here.

   Scaler contract (§4):
   - stepper + presets, oz + ml (ml rounds to nearest 5 — LV.ozToMl5)
   - auto-batch above 5 servings; a manual mode choice permanently
     overrides auto for the rest of the session
   - Morgenthaler dilution from the cocktail style metafield:
     18% spirit_forward / 25% shaken
   - bottle math: 750ml bottles rounded UP, leftover shown,
     dynamic multi-bottle ATC via LVCart
   ============================================================ */
(function () {
  'use strict';

  var BOTTLE_OZ = 25.36;

  function fmtPair(oz) {
    var p = window.LV.fmtOzMl(oz);
    return p.oz + ' oz <i>' + p.ml + ' ml</i>';
  }
  function fmtCount(ing, servings) {
    var n = Math.round(ing.qty * servings * 100) / 100;
    return n + (ing.unit ? ' ' + ing.unit : '');
  }
  function fmtPlain(oz) {
    var p = window.LV.fmtOzMl(oz);
    return p.oz + ' oz · ' + p.ml + ' ml';
  }

  function readJSON(root, selector) {
    var tag = root.querySelector(selector);
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function init(root) {
    var data = readJSON(root, '[data-lv-cocktail-json]');
    if (!data || !Array.isArray(data.ingredients) || data.ingredients.length === 0) return;

    var ingredients = data.ingredients.map(function (i) {
      return {
        name: i.name,
        oz: Number(i.oz) || 0,
        /* Counted amounts [2026-10-28]: {"qty": 2, "unit": "dashes"} for bitters,
           egg whites etc. Shown as "2 dashes", scaled by servings, kept out of the
           liquid totals. Only used when oz is absent. */
        qty: Number(i.qty) || 0,
        unit: i.unit || '',
        /* Unmeasured amounts [2026-10-30]: {"note": "To top" | "Rinse" | "Splash"} —
           shown as written, never scaled, kept out of the totals. */
        note: i.note || '',
        isSpirit: !!(i.is_spirit || i.isSpirit),
        /* Optional in-body link to the bottle's PDP — data-driven, no theme edit.
           Accepts an explicit url, or a product handle from the metaobject. */
        url: i.url || (i.handle ? '/products/' + i.handle : '')
      };
    });
    var spirit = null;
    ingredients.forEach(function (i) { if (!spirit && i.isSpirit) spirit = i; });

    var dilution = data.style === 'spirit_forward' ? 0.18 : data.style === 'built' ? 0 : 0.25;
    var noWater = dilution === 0; /* built/highball drinks dilute in the glass, not the batch */
    var autoBatchAt = 5;

    var els = {
      servings: root.querySelector('[data-lv-servings]'),
      dec: root.querySelector('[data-lv-dec]'),
      inc: root.querySelector('[data-lv-inc]'),
      presets: root.querySelectorAll('[data-lv-preset]'),
      modeInd: root.querySelector('[data-lv-mode-ind]'),
      modeBatch: root.querySelector('[data-lv-mode-batch]'),
      batchJump: root.querySelector('[data-lv-batch-jump]'),
      ingList: root.querySelector('[data-lv-ing-list]'),
      batchWater: root.querySelector('[data-lv-batch-water]'),
      waterAmt: root.querySelector('[data-lv-water-amt]'),
      garnishAmt: root.querySelector('[data-lv-garnish-amt]'),
      totalVol: root.querySelector('[data-lv-total-vol]'),
      bottleMath: root.querySelector('[data-lv-bottle-math]'),
      bottleAtc: root.querySelector('[data-lv-bottle-atc]'),
      dilutionCard: root.querySelector('[data-lv-dilution-card]'),
      perBottle: root.querySelector('[data-lv-per-bottle]'),
      batchDetails: root.querySelector('[data-lv-batch-details]')
    };
    if (!els.servings || !els.ingList) return;

    var servings = 1;
    var batch = false;
    var modeSource = 'auto'; /* manual choice permanently overrides auto */

    function setMode(b) {
      batch = b;
      if (els.modeBatch) els.modeBatch.classList.toggle('on', b);
      if (els.modeInd) els.modeInd.classList.toggle('on', !b);
      if (els.batchJump) els.batchJump.hidden = !b || noWater;
      /* Compact layout [2026-10-30]: the batching tools live in a collapsed "Making a
         batch?" panel; open it the moment batch mode turns on (auto above 5 servings, or
         by choice) so the water, dilution and bottle math are visible. */
      if (b && els.batchDetails && !els.batchDetails.open) els.batchDetails.open = true;
    }

    function render() {
      servings = window.LV.parseQty(els.servings.value, 1);
      els.servings.value = servings;
      if (modeSource === 'auto') setMode(servings > autoBatchAt);

      var totalIng = 0;
      var list = '';
      ingredients.forEach(function (ing) {
        var amt = ing.oz * servings;
        totalIng += amt;
        var label = ing.url
          ? '<a href="' + ing.url + '">' + ing.name + '</a>'
          : ing.name;
        var shown = (!ing.oz && ing.qty) ? fmtCount(ing, servings) : (!ing.oz && ing.note) ? ing.note : fmtPair(amt);
        list += '<div class="lv-ing"><b>' + label + '</b><span>' + shown + '</span></div>';
      });
      els.ingList.innerHTML = list;

      var water = (batch && !noWater) ? totalIng * dilution : 0;
      if (els.batchWater) els.batchWater.hidden = !batch || noWater;
      if (els.dilutionCard) els.dilutionCard.hidden = !batch || noWater;
      if (batch && !noWater && els.waterAmt) els.waterAmt.innerHTML = fmtPair(water);
      if (els.garnishAmt && data.garnish) {
        els.garnishAmt.textContent = servings === 1 ? 'Garnish' : servings + ' ' + (data.garnish_plural || 'garnishes');
      }
      if (els.totalVol) els.totalVol.textContent = fmtPlain(totalIng + water);

      /* bottle math (spirit-led) */
      if (spirit && els.bottleMath) {
        var spiritOz = spirit.oz * servings;
        var bottles = Math.ceil(spiritOz / BOTTLE_OZ);
        var leftover = Math.max(0, bottles * BOTTLE_OZ - spiritOz);
        var bm =
          '<div class="lv-bm-row"><span>' + spirit.name + ' needed</span><b>' + fmtPair(spiritOz) + '</b></div>' +
          '<div class="lv-bm-row"><span>750ml bottles</span><b class="need">' + bottles + ' bottle' + (bottles > 1 ? 's' : '') + '</b></div>' +
          '<div class="lv-bm-row"><span>Left in the last bottle</span><b>' + fmtPair(leftover) + '</b></div>';
        ingredients.forEach(function (ing) {
          if (ing.isSpirit) return;
          if (!ing.oz && !ing.qty) return; /* 'To top' / 'Rinse': nothing to total */
          var tot = (!ing.oz && ing.qty) ? fmtCount(ing, servings) : fmtPair(ing.oz * servings);
          bm += '<div class="lv-bm-row"><span>' + ing.name + ' total</span><b>' + tot + '</b></div>';
          var lower = ing.name.toLowerCase();
          if (lower.indexOf('lemon juice') !== -1 || lower.indexOf('lime juice') !== -1) {
            var fruit = lower.indexOf('lemon') !== -1 ? 'Lemons' : 'Limes';
            bm += '<div class="lv-bm-row"><span>' + fruit + ' (~1 oz juice each)</span><b>~' + Math.ceil(ing.oz * servings) + '</b></div>';
          }
        });
        els.bottleMath.innerHTML = bm;

        if (els.bottleAtc && data.spirit_variant) {
          els.bottleAtc.hidden = false;
          els.bottleAtc.dataset.bottles = bottles;
          var label = 'Add ' + bottles + ' bottle' + (bottles > 1 ? 's' : '');
          if (data.spirit_title) label += ' of ' + data.spirit_title;
          label += ' to cart';
          if (data.spirit_price_cents) label += ' — ' + window.LV.fmtUSD(data.spirit_price_cents * bottles);
          els.bottleAtc.textContent = label;
        } else if (els.bottleAtc) {
          els.bottleAtc.hidden = true;
        }
      }

      if (els.perBottle && spirit && spirit.oz > 0) {
        var per = Math.floor(BOTTLE_OZ / spirit.oz);
        els.perBottle.textContent = data.name ? per + ' × ' + data.name : per + ' drinks';
      }
    }

    if (els.dec) els.dec.addEventListener('click', function () {
      els.servings.value = Math.max(1, window.LV.parseQty(els.servings.value, 1) - 1);
      render();
    });
    if (els.inc) els.inc.addEventListener('click', function () {
      els.servings.value = window.LV.parseQty(els.servings.value, 1) + 1;
      render();
    });
    els.servings.addEventListener('input', render);
    els.presets.forEach(function (b) {
      b.addEventListener('click', function () {
        els.servings.value = b.dataset.lvPreset;
        render();
      });
    });
    if (els.modeInd) els.modeInd.addEventListener('click', function () {
      modeSource = 'user'; setMode(false); render();
    });
    if (els.modeBatch) els.modeBatch.addEventListener('click', function () {
      modeSource = 'user'; setMode(true); render();
    });
    if (els.batchJump) els.batchJump.addEventListener('click', function (e) {
      if (els.dilutionCard) {
        e.preventDefault();
        els.dilutionCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    /* "Making a batch?" shortcut beside the servings stepper [2026-10-30]: open the
       collapsed batching panel and bring it into view. */
    var batchOpen = root.querySelector('[data-lv-batch-open]');
    if (batchOpen && els.batchDetails) batchOpen.addEventListener('click', function (e) {
      e.preventDefault();
      els.batchDetails.open = true;
      els.batchDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var sum = els.batchDetails.querySelector('summary');
      if (sum) sum.focus({ preventScroll: true });
    });
    if (els.bottleAtc) els.bottleAtc.addEventListener('click', function () {
      if (data.spirit_variant && window.LVCart) {
        window.LVCart.add(data.spirit_variant, parseInt(els.bottleAtc.dataset.bottles, 10) || 1);
      }
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-lv-cocktail]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
